var map = {
	"./arrowleft.svg": 4145,
	"./attestation.svg": 1403,
	"./bill.svg": 3226,
	"./check_bgc.svg": 9213,
	"./circular.svg": 4240,
	"./clue.svg": 7848,
	"./delete.svg": 1949,
	"./edit.svg": 8352,
	"./exit-fullscreen.svg": 871,
	"./eye-open.svg": 4301,
	"./eye.svg": 4986,
	"./fullscreen.svg": 6286,
	"./guide.svg": 5860,
	"./hamburger-closed.svg": 149,
	"./hamburger-opened.svg": 6929,
	"./home.svg": 9429,
	"./incom.svg": 1860,
	"./language.svg": 9424,
	"./number.svg": 4247,
	"./operate.svg": 2669,
	"./password.svg": 6408,
	"./plus.svg": 5407,
	"./product.svg": 6967,
	"./setting.svg": 1016,
	"./sound.svg": 2665,
	"./tree.svg": 964,
	"./upload.svg": 9794,
	"./user.svg": 42,
	"./userpassword.svg": 4764,
	"./validCode.svg": 9946,
	"./webuser.svg": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;